import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './messages/en/common.json';
import esCommon from './messages/es/common.json';

const STORAGE_KEY = 'ys-events-locale';
const fallbackLng = 'en';
const supportedLngs = ['en', 'es'] as const;

type SupportedLng = typeof supportedLngs[number];

const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;

const initialLanguage: SupportedLng = stored && supportedLngs.includes(stored as SupportedLng)
  ? (stored as SupportedLng)
  : (typeof navigator !== 'undefined' && supportedLngs.includes(navigator.language.slice(0, 2) as SupportedLng)
      ? (navigator.language.slice(0, 2) as SupportedLng)
      : fallbackLng);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      es: { common: esCommon },
    },
    lng: initialLanguage,
    fallbackLng,
    supportedLngs,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    returnObjects: true,
  });

export const changeLanguage = (lng: SupportedLng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lng);
  }
  i18n.changeLanguage(lng);
};

export const getSupportedLanguages = () => supportedLngs;

export default i18n;
